import React, { useState, useEffect } from 'react';
import { Grid, Icon, IconButton, makeStyles, Typography } from '@material-ui/core';
import { blueGrey } from '@material-ui/core/colors';
import InputForm from '../../../components/Forms/InputForm';
import DisplayError from '../../../components/DisplayError';
import RoundedButton from '../../../components/Actions/RoundedButton';


const ResetPassword = (props) => {

    const {system, form, actions} = props

    return ( 
        <div>
            <Grid container alignItems='center'>
                <Grid item>
                    <IconButton onClick={() => actions.onGoToStep(2)}><Icon>arrow_back_ios_new</Icon></IconButton>
                </Grid>
                <Grid item xs>
                    <Typography  variant='h5' style={{fontWeight:600,}}>Reset password</Typography>
                </Grid>
            </Grid>
            <div style={{marginTop:24}}>
                <Typography style={{color:blueGrey[500]}}>
                    Enter your new password
                </Typography>
                <div style={{padding:'24px 0px'}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <InputForm data={form.password} onChange={actions.onChangeForm} />
                        </Grid>
                        <Grid item xs={12}>
                            <InputForm data={form.password_confirmation} onChange={actions.onChangeForm} />
                        </Grid>
                    </Grid>
                </div>
                <div style={{marginTop:32, textAlign:'center'}}>
                    <DisplayError>{system.error}</DisplayError>
                    <RoundedButton loading={system.loading} onClick={actions.onResetPassword}>Update password</RoundedButton>
                </div>
            </div>
            
        </div>
     );
}

const useStyles = makeStyles(theme => ({

}))
 
export default ResetPassword;